import { UserProfile } from "~proto"

/** 兼容 { token, user } 与 { data: { token, user } } 等登录/验证接口返回 */
export function normalizeAuthSession(payload: unknown): { token: string; user?: UserProfile } {
  if (!payload || typeof payload !== "object") return { token: "" }

  const raw = payload as Record<string, unknown>
  const nested =
    raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
      ? (raw.data as Record<string, unknown>)
      : null

  const tokenRaw = raw.token ?? nested?.token
  const token = tokenRaw != null && String(tokenRaw).length > 0 ? String(tokenRaw) : ""

  const userRaw =
    raw.user ??
    nested?.user ??
    (nested && (nested.id != null || nested.user_id != null) ? nested : null) ??
    (raw.id != null || raw.user_id != null ? raw : null)

  const user =
    userRaw && typeof userRaw === "object" ? (userRaw as UserProfile) : undefined

  return { token, user }
}
